(function () {
    'use strict';

    angular
        .module('sodAppointmentSelector')
        .factory('action-open-appointment-selector', actionFunc);

    function actionFunc(DialogManager, AppointmentSelectorConstant, $templateCache) {
        return function (options) {
            const dialogOptions = angular.merge(
                {},
                {
                    // functionality shouldn't change regardless of view. So we Hardcode the Controller
                    // Otherwise, options can override it.
                    controller: 'AppointmentSelectorController',
                    template: $templateCache.get('common/libraries/appointment-selector/appointment-selector'),
                    dialog_options: {
                        modalSize: 'medium modal-height-restrict-without-footer',
                        classes: {
                            wrapper: 'form-block'
                        },
                        list: {
                            autoBind: true
                        },
                        title: "Create an Appointment",
                        participants: {

                        },
                        availability: {

                        }
                    }
                },
                {
                    // test data. to remove
                    dialog_options: {
                        datasources: {

                        }
                    }
                },
                options
            );

            return DialogManager.init(AppointmentSelectorConstant.APPOINTMENT_SELECTOR_DIALOG_IDENTIFIER, dialogOptions);
        };
    }
})();